import { useEffect } from 'react';
import { breakpoints } from '../styles/theme';
import { useTheme } from '@hooks/useTheme';
import { useMediaQuery } from '@hooks/useMediaquery';
import { rem } from 'polished';
import { useUserDuck } from '@hooks/useUserDuck';

export const ORDER_PANEL_ID = 'orderPanel';
export const CAR_GALLERY_ID = 'carGallery';

export const useOrderPanelHeight = (promotionalText: string) => {
    const theme = useTheme();
    const lg = useMediaQuery(`(min-width: ${theme.flexboxgrid.breakpoints.lg}em)`);
    const { isUserLoggedInAsDealer } = useUserDuck();

    useEffect(() => {
        const carGallery = document.getElementById(CAR_GALLERY_ID);

        if (lg) {
            const orderPanel = document.getElementById(ORDER_PANEL_ID);

            if (orderPanel && carGallery && orderPanel?.offsetWidth >= breakpoints.md) {
                carGallery.style.top = `${orderPanel?.offsetHeight + 10 + rem(isUserLoggedInAsDealer ? 36 : 0)}px`;
            }
        } else {
            carGallery.style.top = `auto`;
        }
    }, [promotionalText, lg, isUserLoggedInAsDealer]);
};
